import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material'
import useFetchOrganizacion from 'common/hooks/useFetchOrganizacion'
import i18n from 'lang/idiomas'
import { useEffect, useState } from 'react'

const SelectorOrganizacionCompras = ({
  organizacionCompras = '',
  handleChange = () => {},
  grupoBalance = '',
  label = i18n.t('efactura.orgcomp', { defaultValue: 'Organización Compras' }),
  sx = {},
  error = false,
}) => {
  const { response, loading } = useFetchOrganizacion(grupoBalance)
  const [organizaciones, setOrganizaciones] = useState([])

  useEffect(() => {
    setOrganizaciones(response)

    if (response?.length === 1) {
      handleChange(response[0].codigo_org_compras)
    }
  }, [response, handleChange])

  return (
    <Box id="box-selector-organizacion-compras" sx={{ ...sx }}>
      {!loading && organizaciones?.length !== 1 && (
        <FormControl fullWidth error={error}>
          <Typography variant="body1">{label}</Typography>

          <Select
            id="selector-organizacion-compras"
            displayEmpty
            value={organizacionCompras}
            onChange={(e) => {
              handleChange(e.target.value)
            }}
          >
            <MenuItem value="" disabled>
              {i18n.t('efactura.selorgco', { defaultValue: 'Selecciona una organización' })}
            </MenuItem>
            {!loading &&
              organizaciones.map((item) => (
                <MenuItem key={item.codigo_org_compras} value={item.codigo_org_compras}>
                  {item.nombre}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
    </Box>
  )
}

export default SelectorOrganizacionCompras
